import React from 'react'
import styled from 'styled-components'

interface ExternalLinkProps {
    href: string
    children?: React.ReactNode
    style?: React.CSSProperties
    content?: {
        text: string
        color?: string
        style?: React.CSSProperties
    }
    iconConfig?: {
        side?: 'left' | 'right'
        icon?: string
        color?: string
        style?: React.CSSProperties
    }
}
const ExternalLink = (props: ExternalLinkProps): JSX.Element => {
    const { href, children, content, iconConfig, style } = props

    const IElement = iconConfig?.icon ? (
        <i
            className={iconConfig.icon}
            style={iconConfig?.style || { color: iconConfig?.color || 'var(--blue-500)' }}
        ></i>
    ) : (
        <i
            className="fas fa-external-link-alt"
            style={iconConfig?.style || { color: iconConfig?.color || 'var(--blue-500)' }}
        ></i>
    )

    return (
        <Container side={!iconConfig?.side ? 'right' : iconConfig?.side} style={style || {}}>
            <a href={href}>
                {iconConfig?.side === 'left' && IElement}
                {content?.text || children || ''}
                {!iconConfig?.side ? IElement : iconConfig?.side === 'right' && IElement}
            </a>
        </Container>
    )
}

export default ExternalLink

const Container = styled.div<{ side: 'left' | 'right' }>`
    display: flex;
    justify-content: center;
    align-items: center;
    width: max-content;
    i {
        ${({ side }) => (side === 'left' ? 'margin-right: 8px;' : 'margin-left: 8px;')}
    }
`
